module.exports = __webpack_public_path__ + "FixelDisplay-Regular-0030fa5586360a29f90764c5bff5147d.woff2";